
import _padStart from "lodash/padStart"
import moment from "moment";
import IFormDefinition from "../interfaces/IFormDefinition";

/**
 * Creates readable version of entity id
 * @param id 
 */
export const formatIdLabel = (id: number): string => {
    return "#" + _padStart(("" + id), 2, "0");
};


export const NoteID = () => new Date().getUTCMilliseconds();

export const makeDefaultAuditTitle = (category: IFormDefinition, date?: Date | null) => {
    return `${category.name} ${moment(date).format("DD.MM.YYYY")}`
}